<template>
    <div class="grid-container">
        <div class="box">
            <h2>For scholars:</h2>
            <div>
                <div>
                    <div class="box_title">Live citation tracking</div>
                    <div class="box_content">Stay informed with real-time updates when your work is cited, so they don’t
                        need no more
                        waiting for periodic reports.</div>
                </div>
                <div>
                    <div class="box_title">Enhanced visibility</div>
                    <div class="box_content">Showcase your paper’s contribution using normalized, context-aware metrics to reflect true
                        impact beyond raw numbers.</div>
                </div>
                <div>
                    <div class="box_title">Smarter literature discovery</div>
                    <div class="box_content">Receive curated suggestions of relevant, high-quality research to support your next study or
                        collaboration.</div>
                </div>
            </div>
        </div>

        <div class="box" style="transform: translate(14px, 210px);">
            <h2>For publishers and journals:</h2>
            <div>
                <div>
                    <div class="box_title">Enriched article pages</div>
                    <div class="box_content">Integrate dynamic citation displays, contribution scores, and recommended reads.</div>
                </div>
                <div>
                    <div class="box_title">Matured authors engagement</div>
                    <div class="box_content">Attract high-caliber submissions by offering transparency, recognition, and modern impact
                        tools.</div>
                </div>
                <div>
                    <div class="box_title">Effortless integration</div>
                    <div class="box_content">A lightweight, API-friendly plug-in that seamlessly enhances your existing infrastructure.
                    </div>
                </div>
            </div>
        </div>

        <div class="box">
            <h2>For readers:</h2>
            <div>
                <div>
                    <div class="box_title">Contextual recommendations</div>
                    <div class="box_content">Instantly see related research aligned with your interests powered by smart filtering and
                        contribution relevance.</div>
                </div>
                <div>
                    <div class="box_title">Trustworthy citation and recommendation signals</div>
                    <div class="box_content">Know which articles are truly influential, not just frequently cited, thanks to normalized
                        impact scores.</div>
                </div>
                <div>
                    <div class="box_title">Time-saving exploration</div>
                    <div class="box_content">Navigate research landscapes more efficiently with personalized content curation and
                        intelligent suggestions.</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    }
}
</script>

<style lang='scss' scoped>
.grid-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 80px 30px;
    position: relative;

    .box {
        position: relative;
        width: 100%;
        padding: 30px;
        border: 1px dashed #00bcd4;
        background-color: transparent;
        z-index: 1;
        transition: transform 0.3s;

        h2 {
            font-size: 30px;
        }

        .box_title {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 10px;
        }

        .box_content {
            line-height: 30px;
        }
    }

    /* 样式：右侧盒子向左上角偏移 */
    .box:nth-child(2n) {
        transform: translate(14px, 40px);
        z-index: 2;
    }

    h2 {
        margin-bottom: 10px;
        font-size: 18px;
    }

    ul {
        padding-left: 20px;
    }

    li {
        margin-bottom: 8px;
    }
}
</style>